import React from 'react'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNewTranslation } from 'hooks'
import _ from 'lodash'
import Text from 'particles/Text'
import styled from 'particles/themes/styled'

interface EmptyStateProps {
    width?: string
    title?: string
}

const Loading: React.FC<EmptyStateProps> = ({ width, title }) => {
    const [t] = useNewTranslation()

    let titleText = title

    if (_.isEmpty(title)) {
        titleText = t('loadingState.loadingGenericPageSubtitle')
    }

    return (
        <LoadingContainer width={width}>
            <div className="icon">
                <FontAwesomeIcon icon={faSpinner} size="4x" spin />
            </div>
            {titleText && (
                <div className="loading-title">
                    <Text scale="bodyM700" color="neutralAction" textAlign="center">
                        {titleText}
                    </Text>
                </div>
            )}
        </LoadingContainer>
    )
}

interface LoadingContainerProps {
    width?: string
}

const LoadingContainer = styled.div<LoadingContainerProps>`
    padding: 40px 0px;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    max-width: 1080px;
    gap: ${({ theme }): string => theme.spacing[400]};
    width: ${({ width }): string => (width ? width : '100%')};
    .icon {
        color: ${({ theme }): string => theme.colors.icon.neutralAction};
    }
    .loading-title {
        display: flex;
        justify-content: center;
    }
`

export default Loading
